import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from '@azure/msal-angular';

import { environment } from '../environments/environment';

export function MSALInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: '75b77725-28df-4c9f-87e3-f166a4f8a330',
      authority:
        'https://login.microsoftonline.com/faa7afb6-0fc1-43d6-93e7-a6420b6f9ab8/',
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {

  const protectedResourceMap = new Map([
    ['https://graph.microsoft.com/*', environment.graph.scopes],
    [`${environment.apiUrl}/*`, ['api://3b075642-f5ef-4e55-a0ab-1d0b4db6145b/Data.Read']],
  ])

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.graph.scopes,
    },
    loginFailedRoute: '/login-failed',
  };
}
